import Link from '@eversports/klimt-primitives/legacy/Link'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Svg from '@eversports/klimt-primitives/legacy/Svg'

import FriendsIcon from '../assets/icons/friends.svg'
import { useIntl } from '../localization/react'

import { ColorContrast } from './Header/Header.types'
import NumberOfPendingFriendRequests from './NumberOfPendingFriendRequests'

interface Props {
  colorContrast?: ColorContrast
  to: string
}

const FriendsConnectionButton = ({ colorContrast = ColorContrast.NORMAL, to }: Props) => {
  const intl = useIntl()
  return (
    <Link to={to} ariaLabel={intl.friendsAriaLabel()}>
      <Stack
        direction="row"
        alignItems="center"
        position="relative"
        sx={{ display: { xs: 'none', lg: 'flex' }, cursor: 'pointer', flexShrink: 0 }}
        gap={2}
      >
        <Svg
          src={FriendsIcon}
          color={colorContrast === ColorContrast.NORMAL ? 'black' : 'white'}
          width={24}
          height={24}
        />
        <NumberOfPendingFriendRequests colorContrast={colorContrast} variant="dot" />
      </Stack>
    </Link>
  )
}

export default FriendsConnectionButton
